import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom-v5-compat';

import config from '@/config';
import { Button } from '@/modules/ui';

import { AlertCard } from '../AlertCard';

export const NotFoundSecretAlert = () => {
    return (
        <AlertCard
            title={{ id: 'sharedSecret.alert.notFound.title' }}
            description={{ id: 'sharedSecret.alert.notFound.description' }}
            footer={
                <Link to={config.routes.secrets}>
                    <Button type='default'>
                        <FormattedMessage id='sharedSecret.alert.notFound.button' />
                    </Button>
                </Link>
            }
        />
    );
};
